export const FETCH_REBATE_DATA = 'FETCH_REBATE_DATA';
export const SET_REBATE_DATA = 'SET_REBATE_DATA';
export const RESET_REBATE_DATA = 'RESET_REBATE_DATA';
export const ERROR_REBATE_DATA = 'ERROR_REBATE_DATA';
